import React, { Fragment } from "react";
import ReactDOM from 'react-dom';
import App from './App';
import './estilos.css';
//import './wwwroot/css/layout.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { AuthProvider } from './context/AuthProvider';

ReactDOM.render(
  // <React.StrictMode>
  //   <AuthProvider>
  //     <App />
  //   </AuthProvider>
  // </React.StrictMode>,
  <Fragment>
     <AuthProvider>
     <App />
    </AuthProvider>
  </Fragment>,
  document.getElementById('root')
);



// import React, { Fragment } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import 'react-app-polyfill/ie11'; // For IE 11 support
// import 'react-app-polyfill/stable';
// import './polyfill';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//   //   <App />
//   // </React.StrictMode>
//   <Fragment>
//     <App />
//   </Fragment>
// );